export const baseDomain = 'http://103.53.41.228:9000/'
export const apiV = 'api/v1/'
export const baseURL = baseDomain + apiV